import SummaryStat from "~/components/Admin/Reports/SummaryStat"

const ProductsSummarySection = ({ summary }) => {
  return (
    <div className="pt-2 pb-2 sticky top-0 z-[0] bg-white">
      <SummaryStat key="sold" label="Products Sold" value={summary && summary.total_sold} />
    </div>
  )
}

export default ProductsSummarySection
